import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-659cd39d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "fullscreen-modal__top-title" }
const _hoisted_5 = { class: "fullscreen-modal__title mb-3 mb-md-48" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateListConfigurations = _resolveComponent("DateListConfigurations")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translate('shop.configuration.choose-persons')), 1),
        _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_Transition, {
        name: "login-fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DateListConfigurations, {
            title: _ctx.translate('shop.configuration.add-persons-from-age-groups'),
            allPriceGroups: _ctx.allPriceGroups,
            "ticket-configuration": _ctx.ticketConfigurations,
            selectedCurrency: _ctx.selectedCurrency,
            dateList: _ctx.dateList,
            onChangePriceGroupCounter: _ctx.onChangePriceGroupCounter
          }, null, 8, ["title", "allPriceGroups", "ticket-configuration", "selectedCurrency", "dateList", "onChangePriceGroupCounter"])
        ]),
        _: 1
      })
    ])
  ]))
}